import React from 'react';
import Header from '../components/Header/Header';
import OurStory from '../components/OurStory/OurStory';
import Supplier from '../components/Supplier/Supplier';
import Values from '../components/Values/Values';
import './About.css';

const About = () => {
  return (
    <div className="page-wrapper">
      {/* Hero Section */}
      <div className="hero-wrapper">
        <Header />
        <div
          className="page-hero"
          style={{
            background: 'linear-gradient(rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.7)), url(' + process.env.PUBLIC_URL + '/images/about/about-main.jpg)',
            backgroundPosition: 'center center',
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'cover'
          }}
        >
          <div className="page-hero-content">
            <h1>About Us</h1>
            <p className="hero-description">Learn more about our journey, values, and the team behind our success</p>
            <div className="breadcrumb">
              <a href="/">Home</a>
              <span className="separator">/</span>
              <span className="active">About</span>
            </div>
          </div>
        </div>
      </div>

      {/* Our Story Section */}
      <OurStory />

      {/* Supplier Section */}
      <Supplier />

      {/* Values Section */}
      <Values />
    </div>
  );
};

export default About;
